import { render } from "./ProxyStatusWidget.vue?vue&type=template&id=5d7e4e95&scoped=true"
import script from "./ProxyStatusWidget.vue?vue&type=script&lang=js"
export * from "./ProxyStatusWidget.vue?vue&type=script&lang=js"

import "./ProxyStatusWidget.vue?vue&type=style&index=0&id=5d7e4e95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7e4e95"]])

export default __exports__